:host {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    font-weight: $polaris-font-weight-normal;

    .ti-product-status-container {
        font-size: $polaris-font-size-2;
        line-height: $polaris-line-height-2;
        color: $pl-text-color-primary;
        display: inline-flex;
        align-items: center;
        text-decoration: none;

        ti-tooltip {
            min-width: 350px; // prevents tall and skinny appearance only for desktop, mobile is set by tooltip
            font-size: $polaris-font-size-2;
            left: 2px;
            white-space: normal;

            /*
            This is a new UX Requirement from Polaris to handle the UX issue for how touch-users can interact with the Product-status.
            The decision is to defer the action to the link and not show the tooltip at all for touch devices since the page goes to the product status page,
            similar to the experience on Wikipedia
            */
            @include mix-for-sizes-down(tablet){
                display: none !important;
            }
        }

        svg {
            width: 22px;
            height: 22px;
            margin-right: 7px;
            flex-shrink: 0;
            flex-grow: 1;
            align-self: flex-start;
        }
    }

    .ti-product-status-link {
        color: $polaris-palette-grey7;
        display: flex;
        flex-direction: row;
        align-items: center;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    ::slotted(.ti-product-status-link-hide) {
        display: none;
    }
}

:host(.ti-product-status-active) {
    path {
        fill: $pl-success-color;
    }
}

:host(.ti-product-status-lifebuy) {
    path {
        fill: $polaris-palette-orange6;
    }
}

:host(.ti-product-status-nrnd) {
    path {
        fill: $polaris-palette-yellow6;
    }
}

:host(.ti-product-status-obsolete) {
    path {
        fill: $polaris-palette-red8;
    }
}

:host(.ti-product-status-preview) {
    path {
        fill: $polaris-palette-teal6;
    }
}

:host(.ti-product-status-compact) {
    .ti-product-status-container {
        font-size: $polaris-font-size-1;

        ti-tooltip {
            left: -1px;
        }

        svg {
            width: 16px;
            height: 16px;
            margin-right: 6px;
            margin-top: 1px //alignment adjustment
        }
   }
}



:host(.ti-product-status-theme-dark) {
    /* Change text colors to white for all elements */
    .ti-product-status-container,
    .ti-product-status-link  {
        color:$pl-text-color-primary-contrast!important;
    }
}
